"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onRouteUpdate = void 0;

var devHandler = function devHandler(_ref, _ref2) {
  var _window$analytics;

  var location = _ref.location;
  var eventName = _ref2.eventName;

  if (!window.analytics || typeof window.analytics.page !== "function") {
    console.warn("Unable to locate analytics.js");
    return;
  }

  var args = [{
    path: location.pathname
  }];
  if (eventName) args.unshift(eventName); // This doesn't mimic the call to page, but it is more informative

  (_window$analytics = window.analytics).page.apply(_window$analytics, args);
};

var prodHandler = function prodHandler(_ref3, _ref4) {
  var location = _ref3.location,
      prevLocation = _ref3.prevLocation;
  var eventName = _ref4.eventName;
  if (!window.analytics) return; // Delay tracking to give `window` a chance of being updated

  window.setTimeout(function () {
    if (window.location.pathname === location.pathname) {
      // `window` has updated info, proceed with defaults
      window.analytics.page(eventName);
    } else {
      // `window` has not been updated yet; use Gatsby data to track
      window.analytics.page(eventName, {
        title: null,
        path: location.pathname,
        url: location.href,
        referrer: prevLocation === null || prevLocation === void 0 ? void 0 : prevLocation.href,
        search: location.search
      });
    }
  }, 250);
};

var onRouteUpdate = process.env.NODE_ENV === "production" ? prodHandler : devHandler;
exports.onRouteUpdate = onRouteUpdate;